import React, {Component} from 'react';
import PropTypes from 'prop-types';

class Avatar extends Component {
    render() {
        return (
            <div className="col-auto">
                <div style={{
                    backgroundImage: `url(${this.props.url})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: 80,
                    width: 80,
                }} className={"rounded-circle"}/>
            </div>
        );
    }
}

Avatar.propTypes = {
    url: PropTypes.string.isRequired
}

export default Avatar;
